import React from "react";
import { TextField, Typography, InputAdornment, Grid } from "@mui/material";
import { EmailIcon, UserIcon, Icon91 } from "../../../../assets/icons";

const PersonalInformation = (props) => {
  const { formData, handleChange } = props;
  return (
    <>
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          fontWeight: "bold",
          textAlign: "left",
          fontweight: 600,
          fontSize: "16px",
          leadingTrim: "Cap height",
          lineHeight: "100%",
          letterSpacing: "0px",
          color: "#393939",
        }}
      >
        Personal Information
      </Typography>

      <Grid container rowSpacing={3} columnSpacing={5}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            placeholder="First name"
            name="firstName"
            value={formData.firstName}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[a-zA-Z\s]*$/.test(value)) {
                handleChange(e);
              }
            }}
            onPaste={(e) => {
              const paste = e.clipboardData.getData("text");
              if (!/^[a-zA-Z\s]+$/.test(paste)) {
                e.preventDefault();
              }
            }}
            onKeyDown={(e) => {
              const allowedKeys = [
                "Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete", " "
              ];
              if (
                !/^[a-zA-Z]$/.test(e.key) &&
                !allowedKeys.includes(e.key)
              ) {
                e.preventDefault();
              }
            }}
            sx={{
              boxSizing: "border-box",
              borderRadius: "10px",
              backgroundColor: "#fff",
              borderColor: "#C0C0C0",
              borderWidth: "5px",
              "& .MuiOutlinedInput-root": {
                height: "46px",
                borderColor: "#C0C0C0",
                backgroundColor: "none",
                "&:hover fieldset": {
                  borderColor: "#C0C0C0",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#C0C0C0",
                },
              },
              "& .MuiFormHelperText-root": {
                color: "#FF6666",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <UserIcon />
                </InputAdornment>
              ),
              sx: {
                borderRadius: "10px",
                height: 45,
                fontSize: "16px",
                fontWeight: "400",
              },
            }}
            inputProps={{
              maxLength: 50,
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            placeholder="Last name"
            name="lastName"
            value={formData.lastName}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[a-zA-Z\s]*$/.test(value)) {
                handleChange(e);
              }
            }}
            onPaste={(e) => {
              const paste = e.clipboardData.getData("text");
              if (!/^[a-zA-Z\s]+$/.test(paste)) {
                e.preventDefault();
              }
            }}
            onKeyDown={(e) => {
              const allowedKeys = [
                "Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete", " "
              ];
              if (
                !/^[a-zA-Z]$/.test(e.key) &&
                !allowedKeys.includes(e.key)
              ) {
                e.preventDefault();
              }
            }}
            sx={{
              boxSizing: "border-box",
              borderRadius: "10px",
              backgroundColor: "#fff",
              borderColor: "#C0C0C0",
              borderWidth: "5px",
              "& .MuiOutlinedInput-root": {
                height: "46px",
                borderColor: "#C0C0C0",
                backgroundColor: "none",
                "&:hover fieldset": {
                  borderColor: "#C0C0C0",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#C0C0C0",
                },
              },
              "& .MuiFormHelperText-root": {
                color: "#FF6666",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <UserIcon />
                </InputAdornment>
              ),
              sx: {
                borderRadius: "10px",
                height: 45,
                fontSize: "16px",
                fontWeight: "400",
              },
            }}
            inputProps={{
              maxLength: 50,
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            disabled
            fullWidth
            placeholder="Email address"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            sx={{
              boxSizing: "border-box",
              borderRadius: "10px",
              backgroundColor: "#fff",
              borderColor: "#C0C0C0",
              borderWidth: "5px",
              "& .MuiOutlinedInput-root": {
                height: "46px",
                borderColor: "#C0C0C0",
                backgroundColor: "none",
                "&:hover fieldset": {
                  borderColor: "#C0C0C0",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#C0C0C0",
                },
              },
              "& .MuiFormHelperText-root": {
                color: "#FF6666",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon />
                </InputAdornment>
              ),
              sx: {
                borderRadius: "10px",
                height: 45,
                fontSize: "16px",
                fontWeight: "400",
              },
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            placeholder="Mobile number"
            name="phone"
            value={formData.phone}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d{0,10}$/.test(value)) {
                handleChange(e); // only allow digits up to 10
              }
            }}
            onKeyDown={(e) => {
              const allowedKeys = [
                "Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete"
              ];
              if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
                e.preventDefault(); // block e, +, -, ., letters, etc.
              }
            }}
            onPaste={(e) => {
              const paste = e.clipboardData.getData("text");
              if (!/^\d{1,10}$/.test(paste)) {
                e.preventDefault();
              }
            }}
            inputProps={{ maxLength: 10 }}
            sx={{
              boxSizing: "border-box",
              borderRadius: "10px",
              backgroundColor: "#fff",
              borderColor: "#C0C0C0",
              borderWidth: "5px",
              "& .MuiOutlinedInput-root": {
                height: "46px",
                borderColor: "#C0C0C0",
                backgroundColor: "none",
                "&:hover fieldset": {
                  borderColor: "#C0C0C0",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#C0C0C0",
                },
              },
              "& .MuiFormHelperText-root": {
                color: "#FF6666",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment
                  position="start"
                  sx={{
                    height: "45px",
                    paddingRight: "12px",
                    borderRight: "1px solid #C0C0C0",
                    maxHeight: "46px",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#1D1D1D",
                      fontSize: "16px",
                      transition: "color 0.2s ease-in-out",
                      textDecoration: "none",
                    }}
                  >
                    +91
                  </Typography>
                </InputAdornment>
              ),
              sx: {
                borderRadius: "10px",
                height: 45,
                fontSize: "16px",
                "& input::-ms-reveal, & input::-ms-clear": {
                  display: "none",
                },
                "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                  {
                    display: "none",
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                "& input[type=number]": {
                  MozAppearance: "textfield",
                },
              },
            }}
          />
        </Grid>

        {/* <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type={"date"}
                  placeholder="Select Date of Birth"
                  name="dateOfBirth"
                  value={formData.dateOfBirth}
                  onChange={handleChange}
                  sx={{
                    boxSizing: "border-box",
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                    borderColor: "#C0C0C0",
                    borderWidth: "5px",
                    "& .MuiOutlinedInput-root": {
                      height: "46px",
                      borderColor: "#C0C0C0",
                      backgroundColor: "none",
                      "&:hover fieldset": {
                        borderColor: "#C0C0C0",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#C0C0C0",
                      },
                    },
                    "& .MuiFormHelperText-root": {
                      color: "#FF6666",
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CalendarIcon />
                      </InputAdornment>
                    ),
                    sx: {
                      borderRadius: "10px",
                      height: 45,
                      fontSize: "16px",
                      fontWeight: "400",
                    },
                  }}
                />
              </Grid> */}
      </Grid>
    </>
  );
};

export default PersonalInformation;
